module.exports = __webpack_public_path__ + "img/L2A.473d69b4.jpg";